// extracted by mini-css-extract-plugin
module.exports = {"warning":"Plotly_warning__21-sr","graph":"Plotly_graph__14LBf"};